import { render, staticRenderFns } from "./AppHeaderMenu.vue?vue&type=template&id=b1c89022&scoped=true&lang=pug"
import script from "./AppHeaderMenu.vue?vue&type=script&lang=js"
export * from "./AppHeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderMenu.vue?vue&type=style&index=0&id=b1c89022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c89022",
  null
  
)

export default component.exports